import Vue from 'vue';

function keyAction(obj: any) {

    // var textbox = document.getElementById('obj');
    const sel = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(obj);
    range.collapse(false);
    if (sel) {
        sel.removeAllRanges();
        sel.addRange(range);
    }

}
// function onInput(el: any, ele: any, binding: any, vnode: any) {
//     function handle() {
//         // 只保留数字
//         ele.value = ele.value.replace(/[^\d]/g, '')
//     }

//     return handle
// }
const numberInput = {
    bind(el: any, binding: any, vnode: any) {
        const ele = el.getAttribute("contenteditable") ? el : null;
        ele.oninput = function (e: any) {
            console.log(e);
            this.innerHTML = this.innerHTML.replace(/[\D;]/g, '');
            keyAction(this);
        };
        // const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
        // ele.addEventListener('input', onInput(el, ele, binding, vnode), false)
    }
};
export default numberInput;
